import '../assets/content.css';
import { jsx as o } from "react/jsx-runtime";
import { Portal as l, Overlay as i, Content as m } from "@radix-ui/react-dialog";
import p from "clsx";
import { forwardRef as d } from "react";
import { DEFAULT_SIZE as y } from "../utils.js";
const f = "_overlay_r0z2p_3", _ = "_content_r0z2p_14", r = {
  overlay: f,
  content: _
}, v = d((t, e) => {
  const { className: n, children: a, size: s = y, ...c } = t;
  return /* @__PURE__ */ o(l, { children: /* @__PURE__ */ o(i, { className: r.overlay, children: /* @__PURE__ */ o(
    m,
    {
      ...c,
      ref: e,
      className: p(r.content, n),
      "data-size": s,
      "aria-describedby": void 0,
      children: a
    }
  ) }) });
});
v.displayName = "Dialog.Content";
export {
  v as DialogContent
};
